export const TASK_RUNNER_TASK_STATE = {
	ENQUEUED: 'ENQUEUED',
	RUNNING: 'RUNNING',
	COMPLETE: 'COMPLETE',
	FAILED: 'FAILED',
	CANCEL_REQUESTED: 'CANCEL_REQUESTED',
	CANCELLED: 'CANCELLED',
	DEAD: 'DEAD',
} as const;

export type TASK_RUNNER_TASK_STATE =
	(typeof TASK_RUNNER_TASK_STATE)[keyof typeof TASK_RUNNER_TASK_STATE];

export type SampleProjectServiceInitialState = {
	loading: boolean;
	error: Error | null;
	taskId: string | null;
};
export type CreateJwmSampleProjectStatusResponse = {
	progressPercentage: number;
	status: TASK_RUNNER_TASK_STATE;
	projectKey?: string;
};
